import { useRef, useState, useEffect } from 'react';

import { Messages } from './use-input-validation.types';

type SupportedElement =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

const getCustomMessage = (validity: ValidityState, messages: Messages) => {
  if (validity.badInput) return messages.badInput;
  if (validity.customError) return messages.customError;
  if (validity.patternMismatch) return messages.patternMismatch;
  if (validity.rangeOverflow) return messages.rangeOverflow;
  if (validity.rangeUnderflow) return messages.rangeUnderflow;
  if (validity.stepMismatch) return messages.stepMismatch;
  if (validity.tooLong) return messages.tooLong;
  if (validity.tooShort) return messages.tooShort;
  if (validity.typeMismatch) return messages.typeMismatch;
  if (validity.valueMissing) return messages.valueMissing;
  return undefined;
};

export default (
  customMessages: Messages = {},
  defaultError?: string,
  isError?: boolean,
) => {
  const [error, setError] = useState<string | undefined>();
  const validationEnabled = useRef(false);

  useEffect(() => {
    if (isError && defaultError) {
      setError(defaultError);
    } else {
      setError(undefined);
    }
  }, [isError, defaultError]);

  const onInvalid = (e: React.FormEvent<SupportedElement>) => {
    validationEnabled.current = true;

    const message = getCustomMessage(
      (e.target as HTMLInputElement).validity,
      customMessages,
    );
    setError(message || (e.target as HTMLInputElement)?.validationMessage);
  };

  const onChange = (e: React.ChangeEvent<SupportedElement>) => {
    const message = getCustomMessage(e.target.validity, customMessages);
    setError(message || e.target?.validationMessage || undefined);
  };

  return [onChange, onInvalid, error] as [
    typeof onChange,
    typeof onInvalid,
    typeof error,
  ];
};
